import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from '../styles/Links.module.css';


//Note from Michael: DO NOT open this page directly. Use the Overview page always or else this data may not load or be correct.

const Table = ({ columns, workers, data }) => {
  return (
    <table className={styles.userTable}>
      <tbody>
        <tr>
          {columns.map((column, index) => (
            <td key={index}><strong>{column.Header}</strong></td>
          ))}
        </tr>

        {workers.map((worker, index) => (
          <tr key={index}>
            <td>{worker.worker_id}</td>
            <td>{data[index].Accuracy}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const WorkerScores = () => {
  const [workers, setWorkers] = useState([]);
  const [data, setData] = useState([]);

  const batch_id = localStorage['batch_id'];
  const component_id = localStorage['component_id'];
  const batch = localStorage['batch'];
  const component = localStorage['component_name'];


  //wait for data to load before to the table
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (workers.length > 0 && data.length > 0) {
      setIsLoading(false);
    }
  }, [workers, data]);

  //get all the work ids
  useEffect(() => {
    fetch(`/get_component_workers/${component_id}/${batch_id}`)
      .then((response) => response.json())
      .then((workers) => {
        console.log('Worker data:', workers);
        setWorkers(workers);
      });
  }, [component_id, batch_id]);

  //get all the accuracies
  useEffect(() => {
    fetch(`/get_component_stats/${component_id}/${batch_id}`)
      .then((response) => response.json())
      .then((data) => {
        console.log('Component data:', data);
        setData(data);
      });
  }, [component_id, batch_id]);

  const columns = [
    { Header: 'Worker' },
    { Header: 'Accuracy' },
  ];

  return (
    <Container fluid >
      <Col>
        <Row className="mt-2">
          <div>
            <h5>Batch: {batch}</h5>
            <h5>Component: {component}</h5>
          </div>
          
        </Row>
        <Row>
        {isLoading ? (
            <p>Loading data...</p>
          ) : (
          <Table 
            columns={columns} 
            workers={workers} 
            data={data} 
          />
          )}
        </Row>
      </Col>
    </Container>
  );
};

export default WorkerScores;
